"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var ProductAccordion_1 = require("../ProductAccordion/ProductAccordion");
var media_query_1 = require("../../hooks/media-query");
var ShopTitle_1 = require("./ShopTitle");
var ShopDescription_1 = require("./ShopDescription");
var ShopSelections_1 = require("./ShopSelections");
var ShopAfterpay_1 = require("./ShopAfterpay");
var shopV2_1 = require("../../utils/shopify/shopV2");
var ShopCta_1 = require("./ShopCta");
var ShopGuarantee_1 = require("./ShopGuarantee");
var ShopUpsells_1 = require("./ShopUpsells");
var ShopContext_1 = require("./ShopContext");
var ShopSellingFast_1 = require("../Shop/ShopTopWrapper/ShopSellingFast");
var ShopYotpoReviews_1 = require("./ShopYotpoReviews");
var withShopifyProvider_1 = require("../Shopify/withShopifyProvider");
var withCartProvider_1 = require("../Shopify/withCartProvider");
var ShopUpsellDoubleWrapper_1 = require("../Shop/AbTest/ShopUpsellDoubleWrapper");
var Shop = function () {
    var _a, _b, _c, _d, _e;
    var _f = (0, hooks_1.useContext)(ShopContext_1.default), singleProductBundle = _f.singleProductBundle, options = _f.options, optionIndex = _f.optionIndex, purchaseTypeIndex = _f.purchaseTypeIndex, setPurchaseTypeIndex = _f.setPurchaseTypeIndex, quantityIndex = _f.quantityIndex, shopData = _f.shopData;
    var isDesktop = (0, media_query_1.useMediaQuery)('(min-width: 1025px)');
    var prices = (0, shopV2_1.getPrices)({
        options: options,
        optionIndex: optionIndex,
        purchaseTypeIndex: purchaseTypeIndex,
        quantityIndex: quantityIndex,
        singleProductBundle: singleProductBundle,
    });
    var customerFav = shopData.customerFav && JSON.parse(shopData.customerFav.value);
    var upsells = (_a = shopData.upsell) === null || _a === void 0 ? void 0 : _a.references.nodes;
    var bundleUpsells = (_b = shopData.bundleUpsells) === null || _b === void 0 ? void 0 : _b.references.nodes;
    var purchaseType = (_c = options[optionIndex].purchaseTypes) === null || _c === void 0 ? void 0 : _c.references.nodes[purchaseTypeIndex].purchaseType;
    if (window.isShopUpsellABTest) {
        upsells = (_d = shopData.testUpsell1) === null || _d === void 0 ? void 0 : _d.references.nodes;
        bundleUpsells = (_e = shopData.testBundleUpsells) === null || _e === void 0 ? void 0 : _e.references.nodes;
    }
    var upsellComp = (0, preact_1.h)(preact_1.Fragment, null);
    if (upsells && !bundleUpsells) {
        upsellComp = (0, preact_1.h)(ShopUpsells_1.default, { upsells: upsells });
    }
    else if (bundleUpsells && upsells) {
        upsellComp = (0, preact_1.h)(ShopUpsellDoubleWrapper_1.default, { addOn: upsells, bundleUpsell: bundleUpsells });
    }
    (0, hooks_1.useEffect)(function () {
        var pathNames = [
            '/pages/ovarian-hair',
            '/pages/pms-breakouts',
            '/pages/menopause',
            '/pages/vaginal-health-aid',
        ];
        if (pathNames.includes(window.location.pathname)) {
            setPurchaseTypeIndex(1);
        }
    }, []);
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("div", { class: "shop-v2__shop" },
            (0, preact_1.h)(ShopTitle_1.default, null),
            shopData.defaultProduct && (0, preact_1.h)(ShopYotpoReviews_1.default, null),
            (0, preact_1.h)(ShopDescription_1.default, null),
            shopData.hasSellingFast.value === 'true' && (0, preact_1.h)(ShopSellingFast_1.default, null),
            (0, preact_1.h)(ShopSelections_1.default, null),
            ((purchaseType === null || purchaseType === void 0 ? void 0 : purchaseType.value) === 'One Time' || singleProductBundle) && ((0, preact_1.h)(ShopAfterpay_1.default, { price: prices.price })),
            (0, preact_1.h)(ShopCta_1.default, { prices: prices }),
            shopData.customerFav && ((0, preact_1.h)("div", { class: "shop-v2__customer-fav" },
                (0, preact_1.h)("p", { class: "shop-v2__customer-fav-header" }, customerFav.header),
                (0, preact_1.h)("p", null, customerFav.body))),
            upsellComp,
            (0, preact_1.h)(ShopGuarantee_1.default, null),
            isDesktop && (0, preact_1.h)(ProductAccordion_1.default, null))));
};
exports.default = (0, withShopifyProvider_1.default)((0, withCartProvider_1.default)(Shop));
